import { useEffect } from 'react';
import { preloadImage } from '@utils/common';
import { iArkStore } from '../state/store.js';

/**
 * NB: we preload images on previous and next pages to provide a more seamless
 * transition upon navigation.
 */
function usePreloadImages(currentPageIndex) {
  const data = iArkStore.useSelector(state => state.component.data);
  useEffect(() => {
    const prev = data.pages[currentPageIndex - 1];
    const next = data.pages[currentPageIndex + 1];
    const imagesToPreload = [...(prev?.items.filter(it => it.kind === "image") ?? []), ...(next?.items.filter(it => it.kind === "image") ?? [])];
    imagesToPreload.forEach(it => preloadImage(it.src).catch(() => {
      /** no-op */
    }));
  }, [currentPageIndex, data.pages]);
}

export { usePreloadImages };
//# sourceMappingURL=hook.preload-images.js.map
